import * as React from "react";
const SvgChatProcessIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 20", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 6, cy: 7, r: 6, fill: "#c7adff", style: {
  fill: "#c7adff",
  fill: "color(display-p3 .7818 .6792 1)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fill: "#ebdeff", d: "M2.656 4.526c.142-.299.386-.536.688-.669l2.102-.925a1.38 1.38 0 0 1 1.108 0l2.102.925c.302.133.546.37.688.669l.875 1.842a1.37 1.37 0 0 1 0 1.18l-.875 1.843a1.38 1.38 0 0 1-.688.668l-2.102.926a1.38 1.38 0 0 1-1.108 0l-2.102-.926a1.38 1.38 0 0 1-.688-.668l-.875-1.842a1.38 1.38 0 0 1 0-1.181z", style: {
  fill: "#ebdeff",
  fill: "color(display-p3 .9235 .8708 1)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("rect", { width: 13, height: 13, x: 4.5, y: 6.5, fill: "#cbd5db", rx: 3.5, style: {
  fill: "#cbd5db",
  fill: "color(display-p3 .7961 .8351 .8577)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("rect", { width: 13, height: 13, x: 4.5, y: 6.5, stroke: "#fff", rx: 3.5, style: {
  stroke: "#fff",
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { stroke: "#214b64", strokeLinecap: "round", strokeLinejoin: "round", d: "M11 16.6c.72 0 1.68-.48 1.68-.48l1.619.48a.297.297 0 0 0 .301-.301l-.48-1.139c.458-.782.48-2.16.48-2.16a3.6 3.6 0 1 0-4.978 3.326c.437.18.658.274 1.378.274", style: {
  stroke: "#214b64",
  stroke: "color(display-p3 .1299 .2942 .3928)",
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { stroke: "#214b64", strokeLinejoin: "round", strokeWidth: 0.75, d: "M9.5 12H13m-3.5 2H12", style: {
  stroke: "#214b64",
  stroke: "color(display-p3 .1299 .2942 .3928)",
  strokeOpacity: 1
} }));
export default SvgChatProcessIcon;
